import { getActiveBreakpoints } from 'plugins/responsive';

export default {
  name: 'ResponsiveController',
  render() {
    if (!this.$slots.default) {
      throw new Error('ResponsiveController slot default is required');
    }

    const { breakpoints, width } = this.$screen;

    const breakpoint = getActiveBreakpoints(width, breakpoints)
      .find(([breakpointKey]) => this.$slots[breakpointKey]);

    const slot = breakpoint ? this.$slots[breakpoint[0]] : this.$slots.default;

    return slot;
  },
};
